/** Shared `accept` attribute values for file inputs. */
export const FILE_ACCEPT = {
  catalogImage: "image/jpeg,image/png,image/webp,image/gif",
  image: "image/*",
  video: "video/*",
  imageAndPdf: "image/*,.pdf",
  imageAndVideo: "image/*,video/*",
  supportAttachment: "image/*,video/*,.pdf,.doc,.docx,.txt",
  pdfOnly: "application/pdf,.pdf",
  pdfAndImage: "application/pdf,image/*",
} as const;
